import { render, staticRenderFns } from "./custom-form-component.vue?vue&type=template&id=6ffbe2ca&"
import script from "./custom-form-component.vue?vue&type=script&lang=js&"
export * from "./custom-form-component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports